import { tv } from '~/utils/tv'

export const InputCounterLabelVariants = tv({
  base: 'line-clamp-1 rounded-none px-onepulse font-rdmodern font-regular text-text-neutral',
  variants: {
    size: {
      md: 'text-threepulse',
      ml: 'text-threeandhalfpulse',
      lg: 'text-threeandhalfpulse',
      xl: 'text-threeandhalfpulse',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
      false: '',
    },
    readOnly: {
      true: 'cursor-not-allowed text-text-neutral-readonly',
      false: '',
    },
  },
})
